module.exports = __webpack_public_path__ + "static/qvr_team1-dcd1af96defcc3b0995f2ec8db32209e.svg";